
import HelpText from '@marketplace/components/forms/inputs/shared/help-text.vue'
import InputLabel from '@marketplace/components/forms/inputs/shared/input-label.vue'
import InvalidFeedback from '@marketplace/components/forms/inputs/shared/invalid-feedback.vue'

export default {
    name: 'SelectInput',

    components: {
        InputLabel,
        InvalidFeedback,
        HelpText,
    },

    inheritAttrs: false,

    props: {
        id: {
            type: String,

            /**
             * Set a default id for the text input.
             *
             * @returns {string}
             */
            default() {
                // the `this._uid` is a Vue variable.
                // eslint-disable-next-line
                return `select-input-${this._uid}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        errorMsg: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        optional: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: '',
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        isValid: {
            type: Boolean,
            default: false,
        },
        showStatusIcons: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        defaultOption: {
            type: String,
            default: '',
        },
        inputClass: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            localValue: this.value || this.defaultOption,
        }
    },

    computed: {
        /**
         * Determines the input class based on the current state.
         *
         * @returns {string}
         */
        validityClass() {
            return {
                'border-danger focus:border-danger': this.isInvalid,
                'border-grey-400 focus:border-black':
                    (!this.isValid && !this.isInvalid) ||
                    (this.isValid && !this.isInvalid),
                'pr-12': this.showStatusIcons,
            }
        },
    },

    watch: {
        localValue: {
            handler: function (newValue) {
                this.$emit('input', newValue)
            },
            immediate: true,
        },
    },
    methods: {
        /**
         * Focuses the input.
         */
        focus() {
            this.$refs.input.focus()
        },
    },
}
